import WebsiteLayout from '../../components/LandingPageWrapper'
import AboutValueCard from '../../components/AboutUsPage/AboutValueCard'
import AboutCard from '../../components/AboutUsPage/card'
import WaitlistModal from '../../components/Modal/WaitListModdal'
import { useState } from 'react'
import Metadata from '../../components/Metadata'
import { residentPwaLink } from '../../constants'
const AboutPage = () => {
  const [openModal, setOpenModal] = useState(false)


  const aboutMetadata = {
    title: 'About Us - Safelto',
    description: 'Learn about Safelto - our mission, vision, and values in transforming community management. Discover how we empower residential communities with modern tools.',
    keywords: ['about Safelto', 'company mission', 'community management', 'property management platform', 'our story'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/about',
    type: 'website' as 'website'
  }

  return (
    <div>
      <Metadata {...aboutMetadata} />
      <WebsiteLayout>
        <WaitlistModal open={openModal} onClose={() => setOpenModal(false)} />
        <main className="md:px-24 pt-[60px] md:pt-[100px]">
          {/* Aboutus Section */}
          <section className="space-y-[80px] md:space-y-[100px] px-4 md:px-0">
            <div className="space-y-5 md:space-y-10 ">
              <div className="flex flex-col items-center justify-center space-y-5 text-center md:px-[135px]">
                <div>
                  <h2 className="text-[#0853E4] text-base md:text-2xl ">
                    At the heart of everything we do,
                  </h2>
                  <h3 className="text-[#000] tracking-[0.45px] text-xl md:text-3xl font-bold">
                    Our Approach Is Unique And Tailored To Exceptional Result
                  </h3>
                </div>
                <p className="text-[#6C757D] text-sm md:text-lg font-medium leading-6 sm:leading-7">
                  We employ innovative methods to achieve outstanding outcomes.
                </p>
              </div>
              <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                <a
                  href={residentPwaLink()}
                  className="w-[260px] h-[48px] px-6 rounded-lg text-base font-medium bg-black dark:bg-gray-100 border border-black dark:border-gray-100 text-white dark:text-black hover:bg-gray-800 dark:hover:bg-gray-300 flex items-center justify-center"
                >
                  Use Safelto in your browser
                </a>
                <button className="w-[260px] h-[48px] px-6 rounded-lg text-base font-medium bg-white dark:bg-black border border-gray-300 dark:border-gray-600 text-black dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-900 flex items-center justify-center"
                  onClick={() => setOpenModal(true)}
                >
                  Download Safelto App
                </button>
              </div>
            </div>

            <div
              className="relative max-w-[1249px] mx-auto bg-[#000] rounded-lg py-10 md:py-[108px] px-4"
              style={{
                backgroundImage: `url('/assets/images/about-background.jpeg')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div className="absolute inset-0 bg-black opacity-20 rounded-lg"></div>

              <div className="relative mx-auto max-w-6xl grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-4 justify-center">
                <AboutCard
                  headerText="We envision over"
                  subHeader="+300"
                  description="communities in use"
                />
                <AboutCard
                  headerText="With over"
                  subHeader="+600k"
                  description="residents in use"
                />
                <AboutCard
                  headerText="With over"
                  subHeader="1m"
                  description="global downloads"
                />
              </div>
            </div>
          </section>

          {/* Our Value Section */}
          <section className="my-[100px] max-w-[100%] lg:max-w-[73.125rem] mx-auto space-y-[60px] px-4 sm:px-6 md:px-0">
            <div className="mx-auto flex flex-col items-center text-center md:space-y-4">
              <div>
                <h2 className="text-[#0853E4] text-[13px] sm:text-[24px] md:text-[28px]">
                  Our Values
                </h2>
                <h3 className="text-[#000] leading-tight tracking-[0.45px] text-xl sm:text-4xl md:text-3xl font-semibold md:font-bold mb-4">
                  Our dedicated team is committed to providing exceptional service and
                  passionate about serving you.
                </h3>
              </div>
              <p className="text-[#ADB5BD] text-[13px] md:text-xl leading-8 sm:leading-9 max-w-4xl text-center">
                Customer Service, Technical Support Specialist, Account Manager, Product
                Expert/Specialist, Customer feedback/survey Team and Analytics/reporting
                Team
              </p>
            </div>

            <div className="flex flex-col max-w-[90%] lg:max-w-[73.125rem] mx-auto">
              <AboutValueCard
                headerIcon="/assets/images/about-value.svg"
                headerText="Our Origin History"
                description={
                  <div className="">
                    <p>
                      It started with a simple observation,community life should feel
                      seamless — people coming together, things running smoothly, everyone
                      staying informed and connected. But in reality, the opposite was
                      happening. Communities were struggling, not because they lacked the
                      will, but because they lacked the tools.
                    </p>

                    <p>
                      Safelto was created to provide a smarter, more affordable way for
                      communities to manage themselves. It offers a complete solution with
                      features like:
                    </p>

                    <ul className="list-disc list-inside text-left pl-6">
                    
                      <li> Automated billing and invoicing</li>
                      <li> Visitor and access control</li>
                      <li> Maintenance request tracking</li>
                      <li> Built-in resident communication tools</li>
                      <li> Secure document storage with digital approvals</li>
                      <li> Staff and vendor management tools</li>
                    </ul>

                    <div>
                      Safelto aims to empower communities of all sizes with the tools they
                      need, without sacrificing quality for affordability. The platform is
                      built on three core values:
                      <ul className="list-disc list-inside text-left pl-6">
                        <li>
                          Value: Offering a complete solution at an affordable price
                        </li>
                        <li>Simplicity: Easy to use and manage</li>
                        <li>Scalability: Adapting to the needs of growing communities</li>
                      </ul>
                    </div>

                    <p>
                      Safelto's goal is to set a new standard for community management,
                      making it easier for communities to thrive, grow, and stay connected
                      without breaking the bank.
                    </p>
                  </div>
                }
              />
              <AboutValueCard
                headerIcon="/assets/images/about-value.svg"
                headerText="Mission Statement"
                description={
                  <>
                    <p>
                      Safelto was created to elevate the standard of community living
                      through a smart, unified platform that simplifies operations,
                      enhances security, and brings people closer together.
                    </p>
                    <p>
                      We've drawn inspiration from the giants Amazon, Google, Azure not
                      just for their innovation and scale, but for how they transformed
                      entire industries. Our aim is to bring that same transformative
                      spirit to real estate and community management, with one key
                      difference:
                    </p>
                    <p>
                      Safelto is purpose built to deliver premium, enterprise grade tools
                      without the premium price.
                    </p>
                    <p>
                      In fact, during our early phase, it's completely free. Because we
                      believe growing communities shouldn’t be held back by cost they
                      should grow with us, supported every step of the way.
                    </p>
                  </>
                }
              />

              <AboutValueCard
                headerIcon="/assets/images/about-value.svg"
                headerText="Our Vision"
                description={
                  <>
                    <p>
                      We imagine a future where every community no matter its size has
                      access to the tools it needs to thrive. Safelto is our step toward
                      that future: a platform built to empower managers, support
                      residents, and evolve alongside the communities it serves.
                    </p>
                    <p>
                      Think of it as infrastructure-as-a-service for residential living
                      intelligent, affordable, and accessible to all.
                    </p>
                    <p>
                      Whether you're running a gated estate, a high-rise tower, or an
                      entire residential district, Safelto delivers the same modern
                      automation and professionalism used by the biggest players without
                      the enterprise price tag.
                    </p>
                  </>
                }
              />

              <AboutValueCard
                headerIcon="/assets/images/about-value.svg"
                headerText="Values and Culture"
                description={
                  <>
                    <p>Simplified Estate Management → Effortless Estate Management</p>
                    <br />
                    <p>Scalability → Grows with Your Community</p>
                    <br />
                    <p>Improved Security → Advanced Security You Can Trust</p>
                    <br />
                    <p>Efficient Communication → Connect Everyone Instantly</p>
                    <br />
                    <p>
                      Enhanced Resident Experience → Deliver a Seamless Living Experience
                    </p>
                    <br />
                  </>
                }
              />
            </div>
          </section>
        </main>
      </WebsiteLayout>
    </div>
  )
}

export default AboutPage
